import React from "react";
import { Box, Button, Typography, IconButton } from "@mui/material";
import { LogOut } from "lucide-react";
import logoImage from "../aditum-logo.jpeg";

type Props = {
  userName?: string;
  onLogout: () => void;
};

export default function TopNavBar({ userName = "usuario", onLogout }: Props) {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bgcolor: "#ffffff",
        borderBottom: "1px solid #e5e7eb",
        backdropFilter: "blur(10px)",
        backgroundColor: "rgba(255, 255, 255, 0.95)",
        zIndex: 1000,
        py: 2,
        px: { xs: 2, sm: 3, md: 4 },
      }}
    >
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
        }}
      >
        {/* Left: Logo */}
        <Box
          component="img"
          src={logoImage}
          alt="Aditum Logo"
          sx={{
            height: { xs: 32, sm: 40 },
            width: "auto",
            objectFit: "contain",
            flexShrink: 0,
          }}
        />

        {/* Center: Welcome Message */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 0.5,
          }}
        >
          <Typography
            sx={{
              fontWeight: 500,
              color: "#1a202c",
              fontSize: { xs: "0.875rem", sm: "1rem" },
            }}
          >
            Bienvenido
          </Typography>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              color: "#2563eb",
              fontSize: { xs: "1rem", sm: "1.5rem" },
              textAlign: "center",
              whiteSpace: "normal",
              wordBreak: "break-word",
              textOverflow: "unset",
              overflow: "visible",
              display: "block",
              width: "100%",
              lineHeight: 1.3,
            }}
          >
            {userName}
          </Typography>
        </Box>

        {/* Right: Logout Button */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexShrink: 0 }}>
          {/* Mobile: Icon only */}
          <IconButton
            onClick={onLogout}
            size="small"
            sx={{
              display: { xs: "flex", sm: "none" },
              color: "#ef4444",
              "&:hover": { bgcolor: "#fee2e2" },
            }}
          >
            <LogOut size={18} />
          </IconButton>

          {/* Desktop: Full button */}
          <Button
            onClick={onLogout}
            startIcon={<LogOut size={18} />}
            variant="outlined"
            size="small"
            sx={{
              display: { xs: "none", sm: "flex" },
              textTransform: "none",
              borderColor: "#ef4444",
              color: "#ef4444",
              fontSize: "0.875rem",
              "&:hover": { bgcolor: "#fee2e2" },
            }}
          >
            Cerrar sesión
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
